import Grid from "@mui/material/Grid";
import { InvestedClientsCard } from "./InvestedClientsCard";
import { UnitsOfSaleCard } from "./UnitsOfSaleCard";
import { ProjectsInvestedCard } from "./ProjectsInvestmentsCard";
import { ChurnRateCard } from "./ChurnRateCard";

export const Dashboard = () => {
  return (
    <Grid container spacing={3} marginTop={3}>
      <Grid size={6}>
        <UnitsOfSaleCard />
      </Grid>
      <Grid size={6}>
        <ChurnRateCard />
      </Grid>
      <Grid size={6}>
        <InvestedClientsCard />
      </Grid>
      <Grid size={6}>
        <ProjectsInvestedCard />
      </Grid>
    </Grid>
  );
};
